import React, { useEffect, useState } from "react";
import { QuestionWrapper } from "@learningblocks/storybook-components/lib/Questions/Components/QuestionWrapper";
import { Question } from "@learningblocks/storybook-components/lib/Questions/Components/Question";
import { MainTitle } from "@learningblocks/storybook-components/lib/Questions/Components/MainTitle";
import { Footer } from "@learningblocks/storybook-components/lib/Questions/Components/Footer";
import { SubmitButton } from "@learningblocks/storybook-components/lib/Questions/Components/SubmitButton";
import PropTypes from "prop-types";
import { ResponseArea } from "./ResponseArea";
import "./style.scss";

export function OpenEnded(props) {
  const [enableSubmitButton, setEnableSubmitButton] = useState(false);
  const [responseAreaValue, setResponseAreaValue] = useState("");
  const [renderFeedback, setRenderFeedback] = useState(false);

  const wrapperClass = ` oeq ${props.className}`;

  useEffect(() => {
    if (props.renderFeedback) setRenderFeedback(true);
  }, []);

  function onSubmit() {
    props.submitAnswer({
      componentId: props.id,
      answer: responseAreaValue,
    });
    setRenderFeedback(true);
    setEnableSubmitButton(false);
  }

  function onValueChange(answer) {
    setResponseAreaValue(answer);
  }

  function handleEnableButton(enable) {
    setEnableSubmitButton(enable);
  }

  return (
    <QuestionWrapper className={wrapperClass}>
      <MainTitle title={props.title} className="oeq__mainTitle" />
      <Question
        tabIndex={"0"}
        text={props.question}
        className="oeq__question"
      />
      <ResponseArea
        feedback={props.feedback}
        setEnableSubmitButton={handleEnableButton}
        onValueChange={onValueChange}
        disabled={props.disabled}
        renderFeedback={renderFeedback}
        answer={props.answer}
      />
      <Footer className="oeq__footer">
        <SubmitButton disabled={!enableSubmitButton} onSubmit={onSubmit} />
      </Footer>
    </QuestionWrapper>
  );
}

OpenEnded.propTypes = {
  /**
   * The prop that hold the unique id for the component
   */
  id: PropTypes.number,

  /**
   * The custom classname you wanna inject on the root of the component
   */
  className: PropTypes.string,

  /**
   * The prop that holds the text for the question
   */
  question: PropTypes.string.isRequired,

  /**
   * The prop that holds the text for the question
   */
  answer: PropTypes.string.isRequired,

  /**
   * The prop that disables the question
   */
  disabled: PropTypes.bool,
};

OpenEnded.defaultProps = {
  disabled: false,
  answer: "",
};
